var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Anchor, Box, Heading } from "grommet";
import { Attachment } from "grommet-icons";
import styled from "styled-components";
var CustomAnchor = styled(Anchor)(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  text-decoration: underline;\n  color: black;\n  font-size: 14px;\n  line-height: 22px;\n  font-weight: 400;\n",
    ]))
);
var CustomHeading = styled(Heading)(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  font-size: 18px;\n  line-height: 26px;\n  font-weight: 700;\n",
    ]))
);
export var DocumentItem = function DocumentItem(_ref) {
  var result = _ref.result;
  return /*#__PURE__*/ React.createElement(
    Box,
    {
      flex: true,
      direction: "row",
      align: "center",
      gap: "0.8rem",
    },
    /*#__PURE__*/ React.createElement(
      Box,
      {
        width: "80px",
        height: "80px",
        style: {
          borderRadius: "20px",
        },
        background: "#C4C4C4",
        justify: "center",
        align: "center",
      },
      /*#__PURE__*/ React.createElement(Attachment, null)
    ),
    result.map(function (r) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          key: r.name,
          flex: true,
          direction: "column",
          gap: "8px",
        },
        /*#__PURE__*/ React.createElement(CustomHeading, null, r.label),
        /*#__PURE__*/ React.createElement(
          CustomAnchor,
          {
            href: r.file,
          },
          "\u0421\u043A\u0430\u0447\u0430\u0442\u044C"
        )
      );
    })
  );
};
